import { tv } from 'tailwind-variants'

export const messagePreviewVariants = tv({
  slots: {
    container: 'mt-deca p-deca bg-white rounded-centi',
    background: 'w-full p-deca bg-message-preview-background rounded',
    bubble: 'w-full px-mili py-mili mb-mili rounded-t-mili break-words rounded-br-mili bg-secondary-xlight',
    label: 'h5 mb-deca'
  }
})
